/* eslint-disable max-len */
import { StartNowAppOfflineMessages } from 'app/modules/start-now-app/enums/start-now-app-offline-messages.enum';

export const OfflineMessages = {
  [StartNowAppOfflineMessages.DefaultMessage]: $localize`You have lost the internet connection. You can continue your application after your connection is restored!`,
  [StartNowAppOfflineMessages.AfterCardPayment]: $localize`You have lost the internet connection. You can continue your application after your connection is restored! If you cannot continue and you added a card payment please contact Princess House customer service:`,
};
